/**
 * WineDepo quiz UI v1.6 — results as product selection (WineDepo look).
 * Catalog: Liquid seeds first; if empty, fetch /collections/all/products.json and seed in JS.
 */
(function () {
  'use strict';

  function quizLocale() {
    var root = document.querySelector('[data-quiz-v12]');
    var fromRoot = root && root.getAttribute('data-locale');
    var raw =
      fromRoot ||
      (window.Shopify && (Shopify.locale || Shopify.legacyLocale)) ||
      document.documentElement.getAttribute('lang') ||
      'ru';
    return String(raw).toLowerCase().indexOf('uz') === 0 ? 'uz' : 'ru';
  }

  function qi(ru, uz) {
    return quizLocale() === 'uz' ? uz : ru;
  }

  var SHORT_TITLES_RU = {
    bubbles: 'Как относитесь к пузырькам?',
    colour_route: 'Белое или красное?',
    sweetness: 'Какую сладость предпочитаете?',
    pomegranate_juice: 'Какой гранатовый сок выберете?',
    apples: 'Какое яблоко возьмёте?',
    dessert: 'Какой десерт выберете?',
    tea: 'Какой чай предпочтёте?',
    pasta: 'Какую пасту выберете?',
    fruit_plate: 'Что возьмёте с фруктовой тарелки?',
    cinnamon_coffee: 'Как часто выбираете кофе с корицей?'
  };

  var SHORT_TITLES_UZ = {
    bubbles: 'Pufakchalarga munosabatingiz qanday?',
    colour_route: 'Oq yoki qizil?',
    sweetness: 'Qanday shirinlikni afzal ko‘rasiz?',
    pomegranate_juice: 'Qaysi anor sharbatini tanlaysiz?',
    apples: 'Qaysi olmani olasiz?',
    dessert: 'Qaysi dessertni tanlaysiz?',
    tea: 'Qaysi choyni afzal ko‘rasiz?',
    pasta: 'Qaysi pastani tanlaysiz?',
    fruit_plate: 'Meva tarelkasidan nima olasiz?',
    cinnamon_coffee: 'Koritsali kofenqancha tez-tez tanlaysiz?'
  };

  var SHORT_LABELS_RU = {
    bubbles: { avoid: 'Не люблю', sometimes: 'Иногда', like: 'Люблю', seek: 'Хочу игристое' },
    colour_route: { white: 'Белое', rose: 'Розовое', red: 'Красное', any: 'Без разницы' },
    sweetness: {
      dry_only: 'Только сухое',
      mostly_dry: 'Скорее сухое',
      fruity_sweet: 'Скорее сладкое',
      sweet_wine: 'Сладкое',
      unsure: 'Не знаю'
    },
    pomegranate_juice: { packaged: 'Пакетированный', fresh: 'Свежевыжатый' },
    apples: { green_tart: 'Зелёное кислое', red_juicy: 'Красное сочное', baked_caramel: 'С карамелью' },
    dessert: {
      lemon_sorbet: 'Лимонный сорбет',
      berries_yogurt: 'Ягоды с йогуртом',
      cheesecake: 'Чизкейк',
      chocolate_cake: 'Шоколадный торт'
    },
    tea: { green_jasmine: 'Зелёный', fruit_tea: 'Фруктовый', lemon_choy: 'Лимон чой', strong_black: 'Крепкий' },
    pasta: {
      vegetables_herbs: 'С овощами',
      bolognese: 'Болоньезе',
      alfredo: 'Альфредо'
    },
    fruit_plate: {
      peach: 'Персик',
      apple: 'Яблоко',
      mango: 'Манго',
      cherry: 'Черешня'
    },
    cinnamon_coffee: {
      never: 'Никогда',
      thursdays: 'По четвергам',
      often: 'Часто'
    }
  };

  var SHORT_LABELS_UZ = {
    bubbles: { avoid: 'Yoqtirmayman', sometimes: 'Ba’zan', like: 'Yoqtiraman', seek: 'Ko‘pirtirilgan' },
    colour_route: { white: 'Oq', rose: 'Pushti', red: 'Qizil', any: 'Farqi yo‘q' },
    sweetness: {
      dry_only: 'Faqat quruq',
      mostly_dry: 'Ko‘proq quruq',
      fruity_sweet: 'Ko‘proq shirin',
      sweet_wine: 'Shirin',
      unsure: 'Bilmayman'
    },
    pomegranate_juice: { packaged: 'Paketli', fresh: 'Yangi siqilgan' },
    apples: { green_tart: 'Yashil nordon', red_juicy: 'Qizil shirali', baked_caramel: 'Karamelli' },
    dessert: {
      lemon_sorbet: 'Limon sorbeti',
      berries_yogurt: 'Yogurtli mevachalar',
      cheesecake: 'Chizkeyk',
      chocolate_cake: 'Shokoladli tort'
    },
    tea: { green_jasmine: 'Yashil', fruit_tea: 'Mevali', lemon_choy: 'Limon choy', strong_black: 'Kuchli' },
    pasta: {
      vegetables_herbs: 'Sabzavot bilan',
      bolognese: 'Boloneze',
      alfredo: 'Alfredo'
    },
    fruit_plate: {
      peach: 'Shaftoli',
      apple: 'Olma',
      mango: 'Mongo',
      cherry: 'Olcha'
    },
    cinnamon_coffee: {
      never: 'Hech qachon',
      thursdays: 'Payshanbalarda',
      often: 'Tez-tez'
    }
  };

  function shortTitles() {
    return quizLocale() === 'uz' ? SHORT_TITLES_UZ : SHORT_TITLES_RU;
  }

  function shortLabels() {
    return quizLocale() === 'uz' ? SHORT_LABELS_UZ : SHORT_LABELS_RU;
  }

  function parseJson(el) {
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      console.error('[wd-quiz-v12] JSON parse failed', e);
      return null;
    }
  }

  function labelFor(qId, answer) {
    var map = shortLabels()[qId];
    if (map && map[answer.id]) return map[answer.id];
    return answer.label;
  }

  function formatMoney(cents) {
    if (cents == null || isNaN(cents)) return '';
    var n = Math.round(Number(cents) / 100);
    var localeTag = quizLocale() === 'uz' ? 'uz-UZ' : 'ru-RU';
    return n.toLocaleString(localeTag) + ' ' + qi('сум', 'so‘m');
  }

  function seedProfileFromTitle(handle, title) {
    var h = String(handle || '').toLowerCase();
    var t = String(title || '').toLowerCase();
    var base = {
      recommendable: true,
      profile_version: 'v1.6',
      profile_status: 'approved',
      published: true,
      availableForSale: true
    };

    function pack(extra) {
      return Object.assign({}, base, extra);
    }

    if (
      /prosecco|cava|frizzante|cordon.?negro|ice.?ros|игрист|шампан|brut/.test(t + ' ' + h)
    ) {
      var isRose = /ros|rose|розов/.test(t + ' ' + h);
      return pack({
        colour: isRose ? 'rose' : 'white',
        bubbles_score: 90,
        freshness_score: 80,
        sweetness_score: 18,
        body_score: 30,
        grip_score: 8,
        style_family: isRose ? 'sparkling_round' : 'sparkling_crisp',
        aroma_tags: isRose ? ['floral', 'red_fruit'] : ['citrus_green', 'floral'],
        tasting_summary: isRose
          ? qi('Игристое розовое — ягоды и лёгкая пена.', 'Pushti musallas — mevachalar va yengil ko‘pikli.')
          : qi(
              'Свежее сухое игристое с цитрусовой кислотностью.',
              'Yangi quruq musallas, sitrus kislotaligi bilan.'
            )
      });
    }

    if (
      /sauvignon|pinot.?grigio|chablis|riesling.?trocken|pinot.?blanc|grillo|рислинг|совиньон|пино.?гри/.test(
        t + ' ' + h
      )
    ) {
      return pack({
        colour: 'white',
        bubbles_score: 0,
        freshness_score: 86,
        sweetness_score: 12,
        body_score: 32,
        grip_score: 10,
        style_family: 'crisp_white',
        aroma_tags: ['citrus_green', 'herbal_mineral'],
        tasting_summary: qi(
          'Сухое белое: свежесть, цитрус и минеральность.',
          'Quruq oq: yangilik, sitrus va minerallik.'
        )
      });
    }

    if (/gewurz|lieblich|palava|мускат|полуслад/.test(t + ' ' + h)) {
      return pack({
        colour: 'white',
        bubbles_score: 0,
        freshness_score: 55,
        sweetness_score: 68,
        body_score: 48,
        grip_score: 12,
        style_family: 'aromatic_white',
        aroma_tags: ['floral', 'tropical'],
        tasting_summary: qi(
          'Ароматное белое с фруктовой сладостью.',
          'Mevali shirinligi bilan xushbo‘y oq.'
        )
      });
    }

    if (/chardonnay|trebbiano|шардоне/.test(t + ' ' + h)) {
      return pack({
        colour: 'white',
        bubbles_score: 0,
        freshness_score: 58,
        sweetness_score: 22,
        body_score: 55,
        grip_score: 15,
        style_family: 'round_white',
        aroma_tags: ['orchard_stone', 'spice_oak'],
        tasting_summary: qi(
          'Округлое белое с мягкой текстурой.',
          'Yumshoq teksturali yumaloq oq.'
        )
      });
    }

    if (/ros(?:e|é)|розов/.test(t + ' ' + h)) {
      return pack({
        colour: 'rose',
        bubbles_score: 0,
        freshness_score: 72,
        sweetness_score: 28,
        body_score: 38,
        grip_score: 14,
        style_family: 'dry_rose',
        aroma_tags: ['red_fruit', 'floral'],
        tasting_summary: qi('Сухое розовое: ягоды и свежесть.', 'Quruq pushti: mevachalar va yangilik.')
      });
    }

    if (/kindzmarauli|киндзмараули|alazani.?red|алазан/.test(t + ' ' + h)) {
      return pack({
        colour: 'red',
        bubbles_score: 0,
        freshness_score: 40,
        sweetness_score: 78,
        body_score: 55,
        grip_score: 25,
        style_family: 'sweet_wine',
        aroma_tags: ['red_fruit', 'dark_fruit'],
        tasting_summary: qi('Мягкое полусладкое красное.', 'Yumshoq yarimshirin qizil.')
      });
    }

    if (/pinot.?noir|valpolicella|dornfelder|пино.?нуар/.test(t + ' ' + h)) {
      return pack({
        colour: 'red',
        bubbles_score: 0,
        freshness_score: 68,
        sweetness_score: 20,
        body_score: 42,
        grip_score: 35,
        style_family: 'light_red',
        aroma_tags: ['red_fruit', 'herbal_mineral'],
        tasting_summary: qi(
          'Лёгкое красное с мягкой структурой.',
          'Yengil qizil, yumshoq tuzilmali.'
        )
      });
    }

    if (
      /cabernet|saperavi|malbec|syrah|montepulciano|merlot|каберне|саперави|мальбек|мерло/.test(
        t + ' ' + h
      )
    ) {
      return pack({
        colour: 'red',
        bubbles_score: 0,
        freshness_score: 42,
        sweetness_score: 18,
        body_score: 72,
        grip_score: 78,
        style_family: 'structured_red',
        aroma_tags: ['dark_fruit', 'spice_oak'],
        tasting_summary: qi(
          'Плотное сухое красное с заметной структурой.',
          'Zich quruq qizil, sezilarli tuzilmali.'
        )
      });
    }

    if (/blanc|white|бел|bianco|белый/.test(t + ' ' + h)) {
      return pack({
        colour: 'white',
        bubbles_score: 0,
        freshness_score: 70,
        sweetness_score: 20,
        body_score: 40,
        grip_score: 12,
        style_family: 'crisp_white',
        aroma_tags: ['citrus_green', 'orchard_stone'],
        tasting_summary: qi(
          'Свежее белое повседневного стиля.',
          'Kundalik uslubdagi yangi oq.'
        )
      });
    }

    if (/rouge|rosso|красн|red|красное/.test(t + ' ' + h)) {
      return pack({
        colour: 'red',
        bubbles_score: 0,
        freshness_score: 48,
        sweetness_score: 22,
        body_score: 60,
        grip_score: 55,
        style_family: 'structured_red',
        aroma_tags: ['dark_fruit', 'savoury_earth'],
        tasting_summary: qi(
          'Сухое красное с умеренной структурой.',
          'O‘rtacha tuzilmali quruq qizil.'
        )
      });
    }

    // Generic fallback so every available bottle can enter scoring
    return pack({
      colour: 'red',
      bubbles_score: 0,
      freshness_score: 55,
      sweetness_score: 30,
      body_score: 50,
      grip_score: 40,
      style_family: 'light_red',
      aroma_tags: ['red_fruit', 'orchard_stone'],
      tasting_summary: qi(
        'Универсальный профиль из каталога WineDepo.',
        'WineDepo katalogidan universal profil.'
      )
    });
  }

  function shopifyProductToWine(p) {
    var image =
      p.images && p.images[0]
        ? p.images[0].src || p.images[0]
        : p.featured_image
          ? p.featured_image
          : null;
    var price = p.variants && p.variants[0] ? p.variants[0].price : p.price;
    // products.json price is already in shop currency units as string "123450.00" sometimes
    var priceCents = price;
    if (typeof price === 'string' && price.indexOf('.') !== -1) {
      priceCents = Math.round(parseFloat(price) * 100);
    } else if (typeof price === 'number' && price < 100000) {
      // unlikely cents for UZS; treat as whole sums * 100 if needed
      priceCents = Math.round(price * 100);
    }

    var seeded = seedProfileFromTitle(p.handle, p.title);
    return Object.assign({}, seeded, {
      handle: p.handle,
      title: p.title,
      url: '/products/' + p.handle,
      image: image,
      price: priceCents,
      availableForSale: p.available !== false
    });
  }

  function fetchStorefrontCatalog() {
    var pages = [1, 2, 3];
    return pages
      .reduce(function (chain, page) {
        return chain.then(function (acc) {
          return fetch('/collections/all/products.json?limit=50&page=' + page)
            .then(function (r) {
              if (!r.ok) return acc;
              return r.json().then(function (data) {
                var list = (data && data.products) || [];
                return acc.concat(list);
              });
            })
            .catch(function () {
              return acc;
            });
        });
      }, Promise.resolve([]))
      .then(function (products) {
        var seen = {};
        var wines = [];
        products.forEach(function (p) {
          if (!p || !p.handle || seen[p.handle]) return;
          if (p.available === false) return;
          seen[p.handle] = 1;
          wines.push(shopifyProductToWine(p));
        });
        return wines;
      });
  }

  function fetchRemainingCatalogPages(pages) {
    var requests = [];
    for (var page = 2; page <= pages; page++) {
      requests.push(
        fetch(window.location.pathname + '?page=' + page, {
          headers: { Accept: 'text/html' }
        })
          .then(function (res) {
            return res.ok ? res.text() : '';
          })
          .then(function (html) {
            if (!html) return [];
            var doc = new DOMParser().parseFromString(html, 'text/html');
            return parseJson(doc.querySelector('#wd-quiz-v12-catalog')) || [];
          })
          .catch(function () {
            return [];
          })
      );
    }
    return Promise.all(requests);
  }

  function ensureCatalogue(embedded, config, meta) {
    if (!embedded || !embedded.length) return fetchStorefrontCatalog();

    var pages = meta && meta.pages ? Number(meta.pages) : 1;
    if (!(pages > 1)) {
      return Promise.resolve(rescueCatalogue(embedded, config));
    }

    return fetchRemainingCatalogPages(pages).then(function (chunks) {
      var seen = {};
      var merged = [];
      [embedded].concat(chunks).forEach(function (list) {
        (list || []).forEach(function (wine) {
          if (!wine || !wine.handle || seen[wine.handle]) return;
          seen[wine.handle] = 1;
          merged.push(wine);
        });
      });
      return rescueCatalogue(merged, config);
    });
  }

  function rescueCatalogue(wines, config) {
    var engine = window.WdQuizV12;
    if (!engine || !engine.validateWine || !engine.normalizeWine || !config) return wines;

    var hasValid = false;
    wines.forEach(function (wine) {
      var normalized = engine.normalizeWine(wine);
      if (engine.validateWine(normalized, config).ok) hasValid = true;
    });
    if (hasValid) return wines;

    return wines.map(function (wine) {
      var seeded = seedProfileFromTitle(wine.handle, wine.title);
      return Object.assign({}, seeded, {
        handle: wine.handle,
        title: wine.title,
        url: wine.url,
        image: wine.image,
        price: wine.price,
        published: wine.published !== false,
        availableForSale: wine.availableForSale !== false
      });
    });
  }

  function start(root, config) {
    var embedded = parseJson(root.querySelector('#wd-quiz-v12-catalog')) || [];
    var catalogMeta = parseJson(root.querySelector('#wd-quiz-v12-catalog-meta')) || {};
    var artMap = parseJson(root.querySelector('#wd-quiz-v12-art')) || {};
    var engine = window.WdQuizV12;
    if (!config || !engine) {
      root.innerHTML =
        '<p class="wd-matcher__result-text" style="padding:2rem">' +
        qi('Квиз временно недоступен.', 'Viktorina vaqtincha ishlamayapti.') +
        '</p>';
      return;
    }

    var intro = root.querySelector('[data-quiz-intro]');
    var nameInput = root.querySelector('[data-quiz-name]');
    var startBtn = root.querySelector('[data-quiz-start]');
    var stage = root.querySelector('[data-matcher-stage]');
    var loading = root.querySelector('[data-matcher-loading]');
    var result = root.querySelector('[data-matcher-result]');
    var progressText = root.querySelector('[data-matcher-progress-text]');
    var badge = root.querySelector('[data-matcher-badge]');
    var questionEl = root.querySelector('[data-matcher-question]');
    var visualEl = root.querySelector('[data-matcher-visual]');
    var optionsEl = root.querySelector('[data-matcher-options]');
    var backBtn = root.querySelector('[data-matcher-back]');
    var barFill = root.querySelector('[data-matcher-bar]');
    var resultTitle = root.querySelector('[data-matcher-result-title]');
    var resultText = root.querySelector('[data-matcher-result-text]');
    var resultLink = root.querySelector('[data-matcher-result-link]');
    var retakeBtn = root.querySelector('[data-matcher-retake]');
    var cardsHost = root.querySelector('[data-quiz-v12-cards]');
    var scalesHost = root.querySelector('[data-quiz-v12-scales]');
    var loadingText = root.querySelector('[data-loading-text]');
    var loadingBar = root.querySelector('[data-loading-bar]');
    var loadingPct = root.querySelector('[data-loading-pct]');
    var shell = root.querySelector('.wd-sommelier__shell');
    var profilePanel = root.querySelector('[data-quiz-v12-profile]');
    var profileKicker = root.querySelector('[data-quiz-v12-profile-kicker]');
    var heroHost = root.querySelector('[data-quiz-v12-hero]');
    var matchesSection = root.querySelector('[data-quiz-v12-matches]');

    if (resultLink) resultLink.hidden = true;

    var questions = config.questions || [];
    var step = 0;
    var answers = {};
    var userName = '';
    var catalogue = embedded.slice();

    function show(el) {
      [intro, stage, loading, result].forEach(function (node) {
        if (!node) return;
        var on = node === el;
        node.hidden = !on;
        node.setAttribute('aria-hidden', on ? 'false' : 'true');
        node.style.display = on ? '' : 'none';
      });
      if (shell) {
        shell.classList.toggle('wd-sommelier__shell--wide', el === result);
        shell.classList.toggle('wd-sommelier__shell--stage', el === stage);
      }
    }

    function runLoadingAnimation(work) {
      var progress = 0;
      var timer = window.setInterval(function () {
        progress = Math.min(progress + Math.random() * 11 + 4, 92);
        if (loadingBar) loadingBar.style.width = progress + '%';
        if (loadingPct) loadingPct.textContent = Math.round(progress) + '%';
      }, 160);

      return Promise.resolve()
        .then(work)
        .then(function (outcome) {
          window.clearInterval(timer);
          if (loadingBar) loadingBar.style.width = '100%';
          if (loadingPct) loadingPct.textContent = '100%';
          return new Promise(function (resolve) {
            window.setTimeout(function () {
              resolve(outcome);
            }, 420);
          });
        })
        .catch(function (err) {
          window.clearInterval(timer);
          throw err;
        });
    }

    function beginQuiz() {
      userName = (nameInput && nameInput.value ? nameInput.value : '').trim();
      step = 0;
      answers = {};
      renderStep();
    }

    function renderStep() {
      var q = questions[step];
      if (!q) return finish();

      var total = questions.length;
      progressText.textContent = (step + 1) + ' / ' + total;
      questionEl.textContent = shortTitles()[q.id] || q.title;
      if (badge) badge.hidden = true;

      visualEl.hidden = false;
      visualEl.innerHTML = '';
      if (artMap[q.id]) {
        var img = document.createElement('img');
        img.className = 'wd-sommelier__scene-img';
        img.src = artMap[q.id];
        img.alt = '';
        img.decoding = 'async';
        visualEl.appendChild(img);
      }

      optionsEl.className = 'wd-matcher__options wd-sommelier__options wd-sommelier__options--pills';
      if ((q.answers || []).length >= 4) {
        optionsEl.classList.add('wd-sommelier__options--wrap');
      }

      barFill.style.width = (step / Math.max(total - 1, 1)) * 100 + '%';
      backBtn.hidden = false;
      backBtn.style.visibility = 'visible';

      optionsEl.innerHTML = '';
      (q.answers || []).forEach(function (opt) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'wd-sommelier__pill';
        btn.textContent = labelFor(q.id, opt);
        btn.addEventListener('click', function () {
          Array.prototype.forEach.call(optionsEl.querySelectorAll('.wd-sommelier__pill'), function (p) {
            p.classList.remove('is-selected');
          });
          btn.classList.add('is-selected');
          answers[q.id] = opt.id;
          window.setTimeout(advance, 160);
        });
        optionsEl.appendChild(btn);
      });

      if (q.allowSkip) {
        var skip = document.createElement('button');
        skip.type = 'button';
        skip.className = 'wd-sommelier__skip';
        skip.textContent = qi('Пропустить / не ем это', 'O‘tkazib yuborish / bu men uchun emas');
        skip.addEventListener('click', function () {
          answers[q.id] = 'skip';
          advance();
        });
        optionsEl.appendChild(skip);
      }

      show(stage);
    }

    function advance() {
      if (step < questions.length - 1) {
        step += 1;
        renderStep();
      } else {
        finish();
      }
    }

    function trackOutcome(outcome) {
      var ps = outcome.profileState || {};
      var payload = {
        quizVersion: config.version,
        answers: Object.assign({}, answers),
        profile: ps.profile || null,
        confidence: ps.confidence || null,
        mode: outcome.mode,
        showPercent: !!outcome.showPercent,
        results: (outcome.cards || []).map(function (card) {
          return {
            handle: (card.wine || {}).handle,
            rank: card.rank,
            finalMatch: card.finalMatch,
            displayMatch: card.displayMatch
          };
        })
      };

      try {
        document.dispatchEvent(
          new CustomEvent('wd:quiz:result', { detail: payload })
        );
        if (Array.isArray(window.dataLayer)) {
          window.dataLayer.push(Object.assign({ event: 'wd_quiz_result' }, payload));
        }
      } catch (e) {
        /* analytics must never break the result screen */
      }
    }

    function finish() {
      show(loading);
      if (loadingBar) loadingBar.style.width = '0%';
      if (loadingPct) loadingPct.textContent = '0%';
      if (loadingText) loadingText.hidden = true;

      runLoadingAnimation(function () {
        return ensureCatalogue(catalogue, config, catalogMeta).then(function (wines) {
          catalogue = wines;
          return engine.recommend(config, answers, catalogue);
        });
      })
        .then(function (outcome) {
          if (outcome && outcome.pipelineCounts) {
            try {
              console.info('[wd-quiz-v12] pipeline', outcome.pipelineCounts);
            } catch (e) {}
          }
          trackOutcome(outcome);
          renderResult(outcome);
          show(result);
        })
        .catch(function (err) {
          console.error('[wd-quiz-v12] catalog', err);
          renderResult(engine.recommend(config, answers, catalogue));
          show(result);
        });
    }


    function formatMatchLabel(card, showPercent) {
      if (showPercent && (card.displayMatch != null || card.finalMatch != null)) {
        var pct = card.displayMatch != null ? card.displayMatch : card.finalMatch;
        return qi('Подходит на ', 'Mos keladi ') + pct + '%';
      }
      return qi('Рекомендуем', 'Tavsiya etamiz');
    }

    function joinTraitWords(list) {
      if (!list.length) return '';
      if (list.length === 1) return list[0];
      if (list.length === 2) return list[0] + qi(' и ', ' va ') + list[1];
      return (
        list.slice(0, -1).join(', ') + qi(' и ', ' va ') + list[list.length - 1]
      );
    }

    function buildProfileNarrative(outcome) {
      var p = outcome.profileState && outcome.profileState.profile;
      if (!p) {
        return qi(
          'Ниже — вина из каталога, которые ближе всего к вашим ответам.',
          'Quyida javoblaringizga eng yaqin katalog vinolari.'
        );
      }

      // Adjectives that read naturally as «вам ближе свежие и лёгкие вина».
      var traits = [];
      if (p.freshness >= 65) {
        traits.push(qi('свежие', 'yangi'));
      } else if (p.freshness <= 35) {
        traits.push(qi('мягкие без резкой кислотности', 'keskin nordonliksiz yumshoq'));
      }
      if (p.sweetness >= 60) {
        traits.push(qi('фруктовые и сладковатые', 'mevali va shirinroq'));
      } else if (p.sweetness <= 30) {
        traits.push(qi('сухие', 'quruq'));
      }
      if (p.body >= 65) {
        traits.push(qi('плотные', 'zich'));
      } else if (p.body <= 35) {
        traits.push(qi('лёгкие', 'yengil'));
      }
      if (p.grip >= 65) {
        traits.push(qi('структурные', 'tuzilmasi aniq'));
      } else if (p.grip <= 30) {
        traits.push(qi('мягкие по текстуре', 'teksturasi yumshoq'));
      }
      if (p.bubbles >= 65) {
        traits.push(qi('игристые', 'musallas'));
      }

      if (!traits.length) {
        return qi(
          'Ваш профиль сбалансирован — вам подойдут разные стили, но мы отобрали самые близкие бутылки из каталога.',
          'Profilingiz muvozanatli — turli uslublar mos keladi, lekin katalogdan eng yaqin butilkalarni tanladik.'
        );
      }

      var joined = joinTraitWords(traits.slice(0, 3));
      return (
        qi('По вашим ответам вам ближе ', 'Javoblaringizga ko‘ra sizga ') +
        joined +
        qi(
          ' вина. Ниже — бутылки из каталога WineDepo, которые лучше всего совпадают с этим профилем.',
          ' vinolar yaqinroq. Quyida — ushbu profilga eng mos WineDepo katalogidagi butilkalar.'
        )
      );
    }

    function createResultAtc(wine) {
      if (wine.variant_id) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'wd-quiz-result-card__atc';
        btn.setAttribute('data-wd-add-to-cart', '');
        btn.setAttribute('data-variant-id', String(wine.variant_id));
        btn.textContent = qi('В корзину', 'Savatga');
        return btn;
      }
      var link = document.createElement('a');
      link.className = 'wd-quiz-result-card__atc';
      link.href = wine.url || '/collections/all';
      link.textContent = qi('Смотреть вино', 'Vinoni ko‘rish');
      return link;
    }

    function renderHeroMatch(card, showPercent) {
      if (!heroHost) return;
      heroHost.innerHTML = '';
      heroHost.setAttribute('aria-hidden', 'false');

      var wine = card.wine || {};
      var wrap = document.createElement('div');
      wrap.className = 'wd-quiz-v12__hero-card';

      var frame = document.createElement('div');
      frame.className = 'wd-quiz-v12__hero-frame';
      if (wine.image) {
        var img = document.createElement('img');
        img.className = 'wd-quiz-v12__hero-img';
        img.src = wine.image;
        img.alt = wine.title || '';
        img.loading = 'eager';
        frame.appendChild(img);
      }

      var badge = document.createElement('div');
      badge.className = 'wd-quiz-v12__hero-badge';
      badge.innerHTML =
        '<span class="wd-quiz-v12__hero-brand">WineDepo</span>' +
        '<span class="wd-quiz-v12__hero-match">' +
        formatMatchLabel(card, showPercent) +
        '</span>';

      wrap.appendChild(frame);
      wrap.appendChild(badge);
      heroHost.appendChild(wrap);
    }

    function renderMatchCard(card, showPercent) {
      var wine = card.wine || {};
      var article = document.createElement('article');
      article.className = 'wd-quiz-result-card';

      var media = document.createElement('div');
      media.className = 'wd-quiz-result-card__media';
      if (wine.image) {
        var img = document.createElement('img');
        img.className = 'wd-quiz-result-card__img';
        img.src = wine.image;
        img.alt = wine.title || '';
        img.loading = 'lazy';
        media.appendChild(img);
      }
      article.appendChild(media);

      var match = document.createElement('p');
      match.className = 'wd-quiz-result-card__match';
      match.textContent = formatMatchLabel(card, showPercent).toUpperCase();
      article.appendChild(match);

      var title = document.createElement('h3');
      title.className = 'wd-quiz-result-card__title';
      var titleLink = document.createElement('a');
      titleLink.href = wine.url || '/collections/all';
      titleLink.textContent = wine.title || wine.handle || '';
      title.appendChild(titleLink);
      article.appendChild(title);

      if (wine.tasting_summary) {
        var blurb = document.createElement('p');
        blurb.className = 'wd-quiz-result-card__blurb';
        blurb.textContent = wine.tasting_summary;
        article.appendChild(blurb);
      }

      if (wine.price != null) {
        var price = document.createElement('p');
        price.className = 'wd-quiz-result-card__price';
        price.textContent = formatMoney(wine.price);
        article.appendChild(price);
      }

      article.appendChild(createResultAtc(wine));
      return article;
    }

    function renderResult(outcome) {
      if (cardsHost) cardsHost.innerHTML = '';
      if (scalesHost) scalesHost.innerHTML = '';
      if (heroHost) heroHost.innerHTML = '';
      if (profilePanel) profilePanel.hidden = true;
      if (matchesSection) matchesSection.hidden = true;

      var helloName = userName
        ? qi('Привет, ', 'Salom, ') + userName + '!'
        : qi('Ваш вкусовой профиль', 'Sizning ta’m profilingiz');

      if (outcome.mode === 'need_more_answers') {
        if (profilePanel) profilePanel.hidden = false;
        if (profileKicker) profileKicker.textContent = qi('Нужно больше ответов', 'Yana javob kerak');
        resultTitle.textContent = helloName;
        resultText.textContent = outcome.message || '';
        if (resultLink) resultLink.hidden = false;
        return;
      }

      if (profilePanel) profilePanel.hidden = false;
      if (profileKicker) {
        profileKicker.textContent = qi('Вкусовой профиль', 'Ta’m profili');
      }

      resultTitle.textContent =
        helloName +
        qi(' — ', ' — ') +
        (outcome.profileName || qi('сбалансированный стиль', 'muvozanatli uslub'));
      resultText.textContent = buildProfileNarrative(outcome);
      if (outcome.message) {
        resultText.textContent += ' ' + outcome.message;
      }

      if (scalesHost && outcome.displayScales && outcome.displayScales.length) {
        var row = document.createElement('div');
        row.className = 'wd-quiz-v12__scale-row';
        outcome.displayScales.forEach(function (s) {
          var cell = document.createElement('div');
          cell.className = 'wd-quiz-v12__scale-cell';
          cell.innerHTML =
            '<span class="wd-quiz-v12__scale-name">' +
            s.displayName +
            '</span><span class="wd-quiz-v12__scale-val">' +
            s.level +
            '</span>';
          row.appendChild(cell);
        });
        scalesHost.appendChild(row);
      }

      if (!cardsHost) return;

      if (!outcome.cards.length) {
        if (matchesSection) matchesSection.hidden = false;
        var empty = document.createElement('p');
        empty.className = 'wd-quiz-v12__empty';
        empty.textContent = qi(
          'Не нашли достаточно близких бутылок. Попробуйте другие ответы или откройте каталог.',
          'Yetarli yaqin butilkalar topilmadi. Boshqa javoblarni sinang yoki katalogni oching.'
        );
        cardsHost.appendChild(empty);
        if (resultLink) {
          resultLink.hidden = false;
          resultLink.textContent = qi('Смотреть каталог', 'Katalogni ko‘rish');
        }
        return;
      }

      renderHeroMatch(outcome.cards[0], outcome.showPercent);

      if (matchesSection) matchesSection.hidden = false;
      var grid = document.createElement('div');
      grid.className = 'wd-quiz-match-grid';
      outcome.cards.forEach(function (card) {
        grid.appendChild(renderMatchCard(card, outcome.showPercent));
      });
      cardsHost.appendChild(grid);

      if (resultLink) {
        resultLink.hidden = false;
        resultLink.textContent = qi('Весь каталог', 'Butun katalog');
      }
    }

    function reset() {
      step = 0;
      answers = {};
      if (cardsHost) cardsHost.innerHTML = '';
      if (scalesHost) scalesHost.innerHTML = '';
      if (heroHost) heroHost.innerHTML = '';
      if (profilePanel) profilePanel.hidden = true;
      if (matchesSection) matchesSection.hidden = true;
      if (resultLink) resultLink.hidden = true;
      show(intro || stage);
    }

    // Prefetch catalog in background
    ensureCatalogue(catalogue, config, catalogMeta).then(function (wines) {
      catalogue = wines;
    });

    if (startBtn) startBtn.addEventListener('click', beginQuiz);
    if (nameInput) {
      nameInput.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          beginQuiz();
        }
      });
    }

    backBtn.addEventListener('click', function () {
      if (step === 0) {
        show(intro);
        return;
      }
      var prevQ = questions[step - 1];
      if (prevQ) delete answers[prevQ.id];
      step -= 1;
      renderStep();
    });

    if (retakeBtn) retakeBtn.addEventListener('click', reset);
    show(intro || stage);
  }

  function init(root) {
    if (!root || root.dataset.wdQuizV12Init) return;
    if (root.getAttribute('data-quiz-v12') !== 'true') return;
    root.dataset.wdQuizV12Init = '1';
    root.dataset.wdMatcherInit = '1';

    var configUrl = root.getAttribute('data-quiz-v12-config-url');
    if (!configUrl) return;

    fetch(configUrl)
      .then(function (res) {
        if (!res.ok) throw new Error('config http ' + res.status);
        return res.json();
      })
      .then(function (config) {
        start(root, config);
      })
      .catch(function (err) {
        console.error('[wd-quiz-v12] config load failed', err);
        root.innerHTML =
          '<p class="wd-matcher__result-text" style="padding:2rem">' +
          qi(
            'Не удалось загрузить конфигурацию квиза.',
            'Viktorina konfiguratsiyasini yuklab bo‘lmadi.'
          ) +
          '</p>';
      });
  }

  function boot() {
    document.querySelectorAll('[data-wd-matcher][data-quiz-v12="true"]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-wd-matcher][data-quiz-v12="true"]');
    if (root) {
      delete root.dataset.wdQuizV12Init;
      delete root.dataset.wdMatcherInit;
      init(root);
    }
  });
})();
